import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { getUser } from '../../reducers/auth';
import UserService from '../../services/user.service';
import SubsiteService from '../../services/subsite.service';
import { useForm } from "react-hook-form";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import AddressModal from "../modals/AddressModal";
import { Pencil, Trash } from "react-bootstrap-icons";


const ChooseSubsiteAddress = ({ close, subsiteId }) => {
    const user = useSelector(getUser);
    const [addresses, setAddresses] = React.useState([]);
    const [selectedAddressId, setSelectedAddressId] = React.useState(null);
    const [showModal, setShowModal] = React.useState(false);
    const [currentAddress, setCurrentAddress] = React.useState({});



    useEffect(() => {
        console.log("USER IN ADDRESS MODAL", user);
        let cancelled = false;
        const fetchAddresses = async () => {
            setAddresses([]);
            const response = await SubsiteService.getSubsiteAddresses(subsiteId);
            if (cancelled) return;
            setAddresses(response.data || []);
            if (response.data && response.data.length > 0)
                setSelectedAddressId(response.data[0].id);
        };
        fetchAddresses();
        return () => { cancelled = true; };
    }, [subsiteId]);


    const { register, handleSubmit, formState: { errors }, reset } = useForm({
        defaultValues: { name: "" },
    });

    const {
        register: register2,
        formState: { errors: errors2 },
        handleSubmit: handleSubmit2,
    } = useForm();

    const onSubmit = async (data) => {
        console.log("ON SUBMIT SELECTED ADDRESS", data);

        await SubsiteService.addEditSubsiteAddress(data, subsiteId);
        const response = await SubsiteService.getSubsiteAddresses(subsiteId);
        setAddresses(response.data || []);
        reset({ name: "", street1: "", street2: "", city: "", state: "", zip: "" });
    }

    const onDelete = async (addressId) => {
        var response = await SubsiteService.deleteSubsiteAddress(addressId, subsiteId);
        console.log("ADDRESSES", response);
        setAddresses(response.data || []);

    }

    const onChangeSubmit = async (addressId) => {
        console.log("ON CHANGE SELECTED ADDRESS", selectedAddressId);
        close(true, addresses.find(a => a.id == selectedAddressId));
    }

    const addressModalClose = () => {
        close(false);
    }

    const closeAddressModal = (updatedAddress) => {
        setShowModal(false);
        if (updatedAddress) {
            var currAddresses = addresses;
            for (var i = 0; i < currAddresses.length; i++) {
                if (currAddresses[i].id == updatedAddress.id) {
                    currAddresses[i] = updatedAddress;
                    break;
                }
            }
            setAddresses(currAddresses);
        }
        setCurrentAddress(null);
    }

    return (
        <Container>
            <Row>
                <Col>
                    <span style={{ fontWeight: "bold" }}>Subsite Addresses:</span>
                </Col>
            </Row>
            {addresses && addresses.map((address, index) => {
                return (
                    <Row style={{ margin: 10, padding: 5, border: "1px solid #CCCCCC" }} key={index}>
                        <Col xs={8}>
                            <div style={{ marginLeft: 20 }}>
                                {address.name
                                  ? address.name
                                  : <em style={{ color: "#666" }}>Recipient name at checkout</em>}
                                <br />
                                {address.street}<br />
                                {address.street2 != null && address.street2 != "" && <>{address.street2}<br /></>}
                                {address.city}, {address.state} {address.zipCode}
                            </div>
                        </Col>
                        <Col xs={4} style={{ textAlign: "right" }}>
                            <Pencil onClick={() => { setCurrentAddress(address); setShowModal(true); }} /> &nbsp;
                            <Trash onClick={() => onDelete(address.id)} />
                        </Col>
                    </Row>
                )
            })}
            <Row>
                <Col>
                    <hr />
                </Col>
            </Row>
            <Row>
                <h4>Add a New Address:</h4>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Form.Group className="mb-3" controlId="name">
                        <Form.Label>Name (optional)</Form.Label>
                        <input {...register("name", { required: false })} /><br />
                        <Form.Text className="text-muted">
                            Leave blank to use the ordering user&apos;s name as the ship-to name.
                        </Form.Text>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="street1">
                        <Form.Label>Street</Form.Label>
                        <input {...register("street1", { required: true })} /><br />
                        {errors.street1 && <div className="error" >Street is required</div>}
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="street2">
                        <Form.Label>Apt/Suite Number</Form.Label>
                        <input {...register("street2", { required: false })} /><br />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="city">
                        <Form.Label>City</Form.Label>
                        <input {...register("city", { required: true })} /><br />
                        {errors.city && <div className="error" >City is required</div>}
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="state">
                        <Form.Label>State</Form.Label>
                        <select
                            name="state"
                            {...register("state", { required: true })}
                        >
                            <option value="">Select a State</option>
                            <option value="AL">Alabama</option>
                            <option value="AK">Alaska</option>
                            <option value="AZ">Arizona</option>
                            <option value="AR">Arkansas</option>
                            <option value="CA">California</option>
                            <option value="CO">Colorado</option>
                            <option value="CT">Connecticut</option>
                            <option value="DE">Delaware</option>
                            <option value="DC">District Of Columbia</option>
                            <option value="FL">Florida</option>
                            <option value="GA">Georgia</option>
                            <option value="HI">Hawaii</option>
                            <option value="ID">Idaho</option>
                            <option value="IL">Illinois</option>
                            <option value="IN">Indiana</option>
                            <option value="IA">Iowa</option>
                            <option value="KS">Kansas</option>
                            <option value="KY">Kentucky</option>
                            <option value="LA">Louisiana</option>
                            <option value="ME">Maine</option>
                            <option value="MD">Maryland</option>
                            <option value="MA">Massachusetts</option>
                            <option value="MI">Michigan</option>
                            <option value="MN">Minnesota</option>
                            <option value="MS">Mississippi</option>
                            <option value="MO">Missouri</option>
                            <option value="MT">Montana</option>
                            <option value="NE">Nebraska</option>
                            <option value="NV">Nevada</option>
                            <option value="NH">New Hampshire</option>
                            <option value="NJ">New Jersey</option>
                            <option value="NM">New Mexico</option>
                            <option value="NY">New York</option>
                            <option value="NC">North Carolina</option>
                            <option value="ND">North Dakota</option>
                            <option value="OH">Ohio</option>
                            <option value="OK">Oklahoma</option>
                            <option value="OR">Oregon</option>
                            <option value="PA">Pennsylvania</option>
                            <option value="RI">Rhode Island</option>
                            <option value="SC">South Carolina</option>
                            <option value="SD">South Dakota</option>
                            <option value="TN">Tennessee</option>
                            <option value="TX">Texas</option>
                            <option value="UT">Utah</option>
                            <option value="VT">Vermont</option>
                            <option value="VA">Virginia</option>
                            <option value="WA">Washington</option>
                            <option value="WV">West Virginia</option>
                            <option value="WI">Wisconsin</option>
                            <option value="WY">Wyoming</option>
                        </select>
                        {errors.state?.type === 'required' && <div className="error" >State is required</div>}
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="zip">
                        <Form.Label>Zip Code</Form.Label>
                        <input {...register("zip", { required: true, minLength: 5, maxLength: 10 })} /><br />

                        {errors.zip?.type === 'required' && <div className="error" >Zip Code is required</div>}
                        {(errors.zip?.type === 'minLength' || errors.zip?.type === 'maxLength') && <div className="error" >Zip Code should be 5 or 10 digits</div>}

                    </Form.Group>

                    <Button variant="danger" onClick={addressModalClose}>
                        Cancel
                    </Button>
                    &nbsp;
                    <Button variant="success" onClick={handleSubmit(onSubmit)} type="submit">
                        Add Address
                    </Button>
                </Form>
            </Row>
            <Row>
                <Col>
                    <hr />
                </Col>
            </Row>
            {showModal && currentAddress && (
              <AddressModal
                show={showModal}
                address={currentAddress}
                closeAddressModal={closeAddressModal}
                nameOptional
                isSubsiteAddress
                subsiteId={subsiteId}
              />
            )}

        </Container>
    );
};

export default ChooseSubsiteAddress; 